import { jsx as i } from "react/jsx-runtime";
import { forwardRef as T } from "react";
import f from "./index.es2325.js";
import { PrimitiveTooltip as t } from "./index.es2321.js";
const g = "simple-tooltip", I = T(
  ({ title: o, testId: s = g, children: e, isActive: p = !0, ...d }, m) => {
    var r, n;
    const c = p && (typeof o == "string" && o !== void 0 ? (o == null ? void 0 : o.length) > 0 : (n = (r = o == null ? void 0 : o.props) == null ? void 0 : r.children) == null ? void 0 : n.length);
    return /* @__PURE__ */ i(
      t,
      {
        testId: s,
        tooltipTrigger: e,
        isActive: c,
        ref: m,
        ...d,
        children: /* @__PURE__ */ i("div", { className: f.truncate, children: o })
      }
    );
  }
);
export {
  g as SIMPLE_TOOL_TIP_DEFAULT_TESTID,
  I as SimpleTooltip
};
//# sourceMappingURL=index.es120.js.map
